export enum RecoveryPlanStatus {
  OPEN = "Opened",
  CLOSE = "Closed",
  DELETE = "Deleted",
}
